import {
  FindOrCreateOfficeLocationRequest,
  FindOrCreateOfficeLocationResponse,
  OfficeLocationDictionaryModel,
} from "../models/officeLocation.model";
import { BackendHttpService } from "./backendHttpService";

export class OfficeLocationService extends BackendHttpService {
  private officeLocationsDictionaryCache:
    | OfficeLocationDictionaryModel[]
    | null = null;

  constructor() {
    super("dictionary/officelocations");
  }

  // Clear cache when dictionary changes
  private clearCache(): void {
    this.officeLocationsDictionaryCache = null;
  }

  // Dictionary methods (public read-only access)
  async getOfficeLocationsDictionary(): Promise<
    OfficeLocationDictionaryModel[]
  > {
    if (this.officeLocationsDictionaryCache) {
      return this.officeLocationsDictionaryCache;
    }
    try {
      this.officeLocationsDictionaryCache = await this.get<
        OfficeLocationDictionaryModel[]
      >("");
      return this.officeLocationsDictionaryCache;
    } catch (error) {
      console.error("Error getting office locations dictionary:", error);
      throw error;
    }
  }

  // Find or create office location (used by CV editor and forms)
  async findOrCreateOfficeLocation(
    request: FindOrCreateOfficeLocationRequest
  ): Promise<FindOrCreateOfficeLocationResponse> {
    try {
      const response = await this.get<FindOrCreateOfficeLocationResponse>(
        `/find-or-create?name=${encodeURIComponent(request.name)}${
          request.autoReview ? `&autoReview=${request.autoReview}` : ""
        }`
      );
      // Clear cache if a new location was created
      if (response.wasCreated) {
        this.clearCache();
      }
      return response;
    } catch (error) {
      console.error("Error finding or creating office location:", error);
      throw error;
    }
  }
}
